import React from 'react'
import { FieldRenderProps } from 'react-final-form'
import Icon from '../../Icon'
import { FieldIcon, Input as StyledInput } from './styles'
import { Html, InputData } from './type'

interface Props extends FieldRenderProps<string, HTMLInputElement> {
  id: string
  data: InputData
  html: Html
}


const CheckBox: React.FC<Props> = ({
  id,
  input,
  data,
  html = {
    maxLength: 255,
  },
}) => {

  html = {...html, checked: input.value === html.value, type: 'checkbox'}
  return (
    <>
      {data.icon && (
        <FieldIcon>
          <Icon
            name={data.icon}
          />
        </FieldIcon>
      )}

      <StyledInput
        id={id}
        {...input}
        {...html}
      />
    </>
  )
}

export default CheckBox
